import { NO_KEY,YES_KEY } from '@/common/constants';

const getYesNoBooleanValue = (val?: string) => {
  if (val === YES_KEY) return true;
  if (val === NO_KEY) return false;
  return val;
};

export default getYesNoBooleanValue;